$(document).on('click', '.js-zoom-btn', function() {
  const $this = $(this)
  const $zoomImg = $this.parents('.js-zoom').find('.js-zoom-img')
  const $zoomModalImg = $('.js-modal-zoom-img')
  const zoomImgSrc = $zoomImg.attr('src')

  $zoomModalImg.attr('src', zoomImgSrc)
})
